import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import RocketFit from './RocketFit'
import RocketPicker from './RocketPicker'
import PersonAvatar from "../common/PersonAvatar/PersonAvatar";
import RocketQuestions from "./RocketPicker/RocketQuestions/RocketQuestions";
import ChoiceFeedback from "./ChoiceFeedback/ChoiceFeedback";
import Button from "../../../partials/Button"
import "./Parameters.scss"
import Scroll from '../../../partials/Scroll/Scroll';

function Parameters({ subjects, isfit_rocket, rockets, options, onRightChoice }) {

    const { baseline } = options
    const [currentRocketSelected, setCurrentSelected] = useState()
    const [currentRocketChosen, setCurrentRocketChosen] = useState()
    const [currentRepSpeech, setCurrentRepSpeech] = useState('')
    let [selectedRocketQuestions, setSelectedRocketQuestions] = useState();

    const [ showFeedback, setShowFeedback ] = useState({
        show: false,
        feedback: ''
    })

    const [rocketrep,] = subjects

    useEffect(() => {
        if (rockets.length > 0) {
            setCurrentSelected(rockets[0])
        }
        setCurrentRepSpeech(options.captions?.initialRepSpeech || 'Set Initial Rep Speech')
    }, [])

    React.useEffect(() => {
        console.log(showFeedback)
    }, [showFeedback])

    if (!rockets) {
        return null
    }

    const handleRocketSelected = (rocketSelected) => {
        setSelectedRocketQuestions(undefined)
        setCurrentSelected(rocketSelected)
        setCurrentRepSpeech(rocketSelected.info)

    }
    const handleRocketChosen = (rocketChosen) => {
        setShowFeedback({
            show: true,
            content: rocketChosen.feedback_content,
            speech: rocketChosen.feedback_speech,
        })

        setCurrentRocketChosen(rocketChosen)
    }

    const handleAnswer = (answer => {
        setCurrentRepSpeech(answer)
    })

    const handleFeedBackClose = () => {
        setShowFeedback({
            show: false,
            feedback: ''
        })
        if (onRightChoice) {
            onRightChoice(currentRocketChosen)
        }
    }

    return <>
        <div className="parameters_container">
            <ChoiceFeedback
                show={showFeedback.show}
                speech={showFeedback.speech}
                content={showFeedback.content}
                rocketrep={rocketrep}
                buttonCaption={currentRocketChosen && currentRocketChosen.model === isfit_rocket ? options.captions?.correctChoiceCaption || 'GOOD CHOICE, CONTINUE' : options.captions?.incorrectChoiceCaption || 'TRY AGAIN'}
                onClose={handleFeedBackClose}
                className={currentRocketChosen && currentRocketChosen.model === isfit_rocket?'correct':'incorrect'}
            />
            <RocketPicker rockets={rockets}
                selected={currentRocketSelected}
                onRocketSelected={handleRocketSelected}
                onRocketChosen={handleRocketChosen}
            />
            {
                currentRocketSelected &&
                <RocketFit
                    rocket={currentRocketSelected}
                    {...baseline} />
            }
            <Button text='Choose this Model'
                onClick={() => { handleRocketChosen(currentRocketSelected) }} >
            </Button>
        </div>
        <div className={"rocketinfo_container"}>
            <Scroll>
                <div className={"rocketinfo_container_scroll"}>
                {rocketrep && <PersonAvatar avatar={rocketrep.avatar}
                    name={rocketrep.name}
                    speak={currentRepSpeech}
                    jobtitle={rocketrep.role} />
                }


                <p>Ask a question</p>
                {currentRocketSelected && <RocketQuestions
                    questions={currentRocketSelected.questions}
                    onAnswer={handleAnswer}
                    currentRepSpeech={currentRepSpeech}
                    selected={selectedRocketQuestions}
                    setSelected={setSelectedRocketQuestions}
                    />
                }
                </div>
            </Scroll>
        </div>
    </>

}

export default Parameters

Parameters.propTypes = {
    baseline: PropTypes.object,
    isfit_rocket: PropTypes.any,
    onRightChoice: PropTypes.func,
    options: PropTypes.object,
    rockets: PropTypes.array,
    subjects: PropTypes.any
}
